"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Link;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _events = require("../../utils/events");

var _classnames = _interopRequireDefault(require("classnames"));

var _filterDOMProps = _interopRequireDefault(require("../../utils/filterDOMProps"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
if (process.env.SCALE_MEDIUM && process.env.SCALE_LARGE) {
  require("../../spectrum-css/link/index.css");

  require("../../spectrum-css/link/index-diff.css");
} else if (process.env.SCALE_LARGE) {
  require("../../spectrum-css/link/index-lg.css");
} else {
  require("../../spectrum-css/link/index.css");
}

if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHT) require("../../spectrum-css/link/multiStops/light.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARK) require("../../spectrum-css/link/multiStops/dark.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHTEST) require("../../spectrum-css/link/multiStops/lightest.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARKEST) require("../../spectrum-css/link/multiStops/darkest.css");

function preventDefault(e) {
  if (!e.defaultPrevented) {
    e.preventDefault();
  }
}

function Link(_ref) {
  var subtle = _ref.subtle,
      variant = _ref.variant,
      children = _ref.children,
      className = _ref.className,
      href = _ref.href,
      onClick = _ref.onClick,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["subtle", "variant", "children", "className", "href", "onClick"]);

  if (subtle) {
    console.warn('The "subtle" prop of Link is deprecated. Please use variant="quiet" instead.');
    variant = 'quiet';
  }

  if (variant === 'subtle') {
    console.warn('The "subtle" variant of Link is deprecated. Please use variant="quiet" instead.');
    variant = 'quiet';
  }

  if (!href && typeof onClick === 'function') {
    href = '#';
    onClick = (0, _events.chain)(onClick, preventDefault);
  }

  return _react["default"].createElement("a", (0, _extends2["default"])({
    className: (0, _classnames["default"])('spectrum-Link', (0, _defineProperty2["default"])({}, "spectrum-Link--".concat(variant), variant), className),
    href: href,
    onClick: onClick
  }, (0, _filterDOMProps["default"])(otherProps)), children);
}

Link.propTypes = {
  /** Class to add to the Link */
  className: _propTypes["default"].string,

  /** Link variant */
  variant: _propTypes["default"].oneOf(['quiet', 'subtle', 'overBackground'])
};
Link.displayName = 'Link';